import { ReactElement, useEffect, useRef } from 'react';
import { useBreadcrumbs } from '@client/breadcrumbs/hooks';
import { RemoteRecordHandler } from '@client/common/components/RemoteRecordHandler';
import { useTranslate } from '@client/i18n/hooks';
import { BoxError } from '@client/myAccount/common/components/BoxError';
import { MyAccount } from '@client/myAccount/common/components/MyAccount';
import { MY_ACCOUNT_MENU_ITEM } from '@client/myAccount/common/utils/myAccountMenu';
import { UpdateForm } from '@client/myAccount/newsletters/components/UpdateForm';
import { useClearNewslettersAction, useNewslettersEffect } from '@client/myAccount/newsletters/hooks';
import { ROUTES } from '@client/routes/components/Router/routes';
import { useUrlCreator } from '@client/routes/hooks';
import { CARD_BOX_TITLE_SIZE, CardBox } from 'b2b-components/theme/components/CardBox';

export const ViewPage = (): ReactElement => {
  const t = useTranslate();
  const urlCreator = useUrlCreator();
  const newsletters = useNewslettersEffect();
  const clearNewslettersAction = useClearNewslettersAction();
  const wereNewslettersUpdated = useRef(false);

  const handleNewslettersUpdated = (): void => {
    wereNewslettersUpdated.current = true;
  };

  useEffect(
    (): void => {
      if (wereNewslettersUpdated.current) {
        clearNewslettersAction();
      }
    },
    [],
  );

  useBreadcrumbs([
    {
      title: t('My account'),
      url: urlCreator(ROUTES.myAccount),
    },
    {
      title: t('Newsletters'),
    },
  ]);

  const { data } = newsletters;

  return (
    <MyAccount active={MY_ACCOUNT_MENU_ITEM.newsletterSettings}>
      <RemoteRecordHandler
        remoteRecord={newsletters}
        customErrorComponent={(
          <BoxError
            remoteRecord={newsletters}
            title={t('Newsletter management')}
          />
        )}>
        <CardBox
          className='NewslettersDetailsPage-CardBox'
          title={t('Newsletter management')}
          titleSize={CARD_BOX_TITLE_SIZE.large}
        >
          {!!data && (
            <UpdateForm
              newslettersData={data}
              onNewslettersUpdated={handleNewslettersUpdated}
            />
          )}
        </CardBox>
      </RemoteRecordHandler>
    </MyAccount>
  );
};
